import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faMinusCircle,
  faPlusCircle,
  faWrench,
  faTrash,
  faFileMedical,
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";

import { SessionManager } from "../../utils/functions";
import api from "../../services/client/api";
export default function ListReportsRedeSus({
  reports,
  token,
  username,
  refreshReports,
}) {
  const [expanded, setExpanded] = useState(false);

  const [confirmModal, setConfirmModal] = useState(false);
  const [downloading, setDownloading] = useState(null);

  const session = SessionManager();

  const download = useCallback(
    async (numberReport, typeReport) => {
      setDownloading(numberReport);

      try {
        const response = await api()
          .report()
          .downloadRedeSus(token, numberReport, typeReport);

        if (response.status === 401) {
          return session.logoff();
        }

        if (response.status === 200) {
          window.open(response.output);
        }
      } catch (error) {
        console.error("Erro no download:", error);
      } finally {
        setDownloading(null);
      }
    },
    [session, token],
  );

  if (!reports || reports.length === 0) return null;

  const mainReport = reports[0];
  const hasMore = reports.length > 1;

  return (
    <>
      {/* Linha principal */}
      <tr>
        <td style={{ textAlign: "center" }}>
          {hasMore && (
            <FontAwesomeIcon
              icon={expanded ? faMinusCircle : faPlusCircle} // usa + quando fechado e − quando expandido
              color="#007DC3"
              style={{ cursor: "pointer", margin: 10, fontSize: 19 }}
              onClick={() => setExpanded(!expanded)}
              title={
                expanded
                  ? "Ocultar outros exames deste paciente."
                  : "Mostrar outros exames deste paciente."
              }
            />
          )}
        </td>

        <td style={{ textAlign: "center" }}>{mainReport.CodRequisicao}</td>

        <td style={{ textAlign: "center" }}>{mainReport.NomPaciente}</td>

        <td style={{ textAlign: "center" }}>
          {new Date(mainReport.DtaSolicitacao).toLocaleDateString("pt-BR")}
        </td>

        <td style={{ textAlign: "center" }}>{mainReport.DesDiagnosticoPtg}</td>

        <td style={{ textAlign: "center" }}>{mainReport.DesTopografiaPtg}</td>

        <td style={{ textAlign: "center" }}>{mainReport.NomExame}</td>

        <td style={{ textAlign: "center" }}>{mainReport.MatConvenio}</td>

        <td style={{ textAlign: "center" }}>{mainReport.CartaoNacionalSUS}</td>

        <td style={{ textAlign: "center" }}>{mainReport.CNES}</td>

        <td style={{ textAlign: "center" }}>{mainReport.NomEstabelecimento}</td>

        <td style={{ textAlign: "center" }}>{mainReport.DesEvento}</td>

        <td style={{ textAlign: "center" }}>
          <Button
            color="info"
            disabled={downloading === mainReport.CodRequisicao}
            onClick={() =>
              download(mainReport.CodRequisicao, mainReport.Tipo_Laudo)
            }
          >
            {downloading === mainReport.CodRequisicao ? (
              <Spinner size="sm" />
            ) : (
              <FontAwesomeIcon
                icon={faDownload}
                title={"Fazer download do Laudo"}
              />
            )}
          </Button>
        </td>
      </tr>
      {/* Linhas expandidas */}
      {expanded &&
        reports.slice(1).map((report, index) => (
          <tr key={index} style={{ backgroundColor: "#f9f9f9" }}>
            <td style={{ textAlign: "center", paddingLeft: 10 }}></td>

            <td style={{ textAlign: "center" }}>{report.CodRequisicao}</td>

            <td style={{ textAlign: "center" }}>{report.NomPaciente}</td>

            <td style={{ textAlign: "center" }}>
              {new Date(report.DtaSolicitacao).toLocaleDateString("pt-BR")}
            </td>

            <td style={{ textAlign: "center" }}>{report.DesDiagnosticoPtg}</td>

            <td style={{ textAlign: "center" }}>{report.DesTopografiaPtg}</td>

            <td style={{ textAlign: "center" }}>{report.NomExame}</td>

            <td style={{ textAlign: "center" }}>{report.MatConvenio}</td>

            <td style={{ textAlign: "center" }}>{report.CartaoNacionalSUS}</td>

            <td style={{ textAlign: "center" }}>{report.CNES}</td>

            <td style={{ textAlign: "center" }}>{report.NomEstabelecimento}</td>

            <td style={{ textAlign: "center" }}>{report.DesEvento}</td>

            <td style={{ textAlign: "center" }}>
              <Button
                color="info"
                disabled={downloading === report.CodRequisicao}
                onClick={() =>
                  download(report.CodRequisicao, report.Tipo_Laudo)
                }
              >
                {downloading === report.CodRequisicao ? (
                  <Spinner size="sm" />
                ) : (
                  <FontAwesomeIcon
                    icon={faDownload}
                    title={"Fazer download do Laudo"}
                  />
                )}
              </Button>
            </td>
          </tr>
        ))}
    </>
  );
}
